export const buildUserLookupCriteria = (user = {}) => {
  if (!user || typeof user !== "object") {
    return {};
  }

  return {
    ...(user.email ? { email: user.email } : {}),
    ...(user.primaryId ? { primaryId: user.primaryId } : {})
  };
};

export const buildStudentAttendanceCriteria = (studentId, scheduledProductId, companyId) => ({
  student: { primaryId: Number(studentId) || studentId },
  ...(scheduledProductId
    ? { courseSchedule: { primaryId: Number(scheduledProductId) || scheduledProductId } }
    : {}),
  ...(companyId
    ? { company: { primaryId: Number(companyId) || companyId } }
    : {})
});

const getDefaultStorage = () => (
  typeof window !== "undefined" && window.localStorage
    ? window.localStorage
    : { getItem: () => null }
);

export const buildCompanyUserCriteria = (companyId, storage = getDefaultStorage()) => ({
  company: { primaryId: companyId },
  userRole: storage.getItem("userRole"),
  email: storage.getItem("email")
});

export const buildShoppingCartLineItemPayload = (lineItemOrCartId, product) => {
  if (product === undefined) {
    return lineItemOrCartId;
  }

  return {
    primaryId: lineItemOrCartId,
    product
  };
};

export const buildUploadContentFormData = (file, companyFolderId, contentType) => {
  const formData = new FormData();
  formData.append("file", file);
  if (companyFolderId) formData.append("companyFolderId", companyFolderId);
  if (contentType) formData.append("contentType", contentType);
  return formData;
};

export const buildVideoUploadFormData = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return formData;
};
